import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { resolveTheme } from '../constants/themes';

const API_URL = process.env.REACT_APP_API_URL || '';
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(resolveTheme({}));

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`)
      .then(res => setTheme(resolveTheme(res.data)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--color-background-secondary', theme.surfaceAlt);
    root.style.setProperty('--color-border-tertiary', theme.border);
    document.body.style.background = theme.background;
    document.body.style.color = theme.text;
  }, [theme]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
